import { useEffect, useRef, useState, type FC } from 'react';
import { apiErrorMessage, webLoginLinkApi } from '../api/client';
import { useAppStore } from '../store/useAppStore';
import { t } from '../i18n';

const BOT_USERNAME =
  (import.meta.env.VITE_BOT_USERNAME as string) || 'shaftoliuzbot';

/**
 * Saytdan kirish — Telegramdan TASHQARIDA.
 *
 * Ilova ilgari bu holatda oʻzini `document.body.innerHTML` bilan
 * oʻchirib qoʻyardi ("Access Denied"). Endi ikki yoʻl bor:
 *
 *  1. Telegram Login Widget — bir bosish, parolsiz.
 *  2. Botdagi bir martalik havola — widget ishlamasa (domen hali
 *     bogʻlanmagan, brauzer uchinchi tomon freymini bloklagan).
 *
 * Ikkinchisi ZAXIRA sifatida ataylab qoldirildi: widget Telegramning
 * `oauth.telegram.org` freymiga tayanadi va uni bloklaydigan brauzer
 * yoki tarmoq bor. Bunday holatda foydalanuvchi butunlay qamalib
 * qolmasligi kerak.
 */
export const LoginPage: FC = () => {
  const setWebToken = useAppStore((s) => s.setWebToken);
  const [error, setError] = useState<string | null>(null);
  const [exchanging, setExchanging] = useState(false);
  const widgetSlot = useRef<HTMLDivElement>(null);

  /*
   * Botdagi havola bilan kelgan boʻlsa — darhol sessiyaga
   * almashtiramiz. Token manzilda qolmasligi uchun URL tozalanadi:
   * u 10 daqiqa yashaydi, lekin brauzer tarixida qolishi shart emas.
   */
  useEffect(() => {
    const hash = window.location.hash || '';
    const query = hash.includes('?') ? hash.slice(hash.indexOf('?')) : '';
    const token =
      new URLSearchParams(query).get('t') ||
      new URLSearchParams(window.location.search).get('t');
    if (!token) return;

    setExchanging(true);
    webLoginLinkApi(token)
      .then((r) => {
        setWebToken(r.access_token);
        window.location.replace(window.location.pathname);
      })
      .catch((e) => {
        setError(
          apiErrorMessage(e, 'Havola eskirgan. Botdan yangisini oling.'),
        );
        setExchanging(false);
      });
  }, [setWebToken]);

  /*
   * Telegram Login Widget — skript `telegram.org` dan yuklanadi.
   * Backend CSP'sida `scriptSrc` ga aynan shu domen kiritilgan, ya'ni
   * u bloklanmaydi (tashqi skriptlarning qolgani bloklanadi).
   */
  useEffect(() => {
    const joy = widgetSlot.current;
    if (!joy || joy.childElementCount > 0) return;

    // Widget natijani GLOBAL funksiya orqali qaytaradi.
    (window as any).shaftoliLogin = async (user: Record<string, string>) => {
      try {
        const { webLoginWidgetApi } = await import('../api/client');
        const r = await webLoginWidgetApi(user);
        setWebToken(r.access_token);
        window.location.reload();
      } catch (e) {
        setError(apiErrorMessage(e, 'Kirib boʻlmadi.'));
      }
    };

    const s = document.createElement('script');
    s.src = 'https://telegram.org/js/telegram-widget.js?22';
    s.async = true;
    s.setAttribute('data-telegram-login', BOT_USERNAME);
    s.setAttribute('data-size', 'large');
    s.setAttribute('data-radius', '10');
    s.setAttribute('data-onauth', 'shaftoliLogin(user)');
    s.setAttribute('data-request-access', 'write');
    joy.appendChild(s);
  }, [setWebToken]);

  if (exchanging) {
    return (
      <main className="page stack">
        <div className="skeleton skeleton-card" />
        <div className="skeleton skeleton-card" />
      </main>
    );
  }

  return (
    <main className="page">
      <div
        className="card"
        style={{ maxWidth: 420, margin: '10vh auto 0', textAlign: 'center' }}
      >
        <h1 style={{ marginBottom: 'var(--space-2)' }}>Shaftoli</h1>
        <p
          className="secondary text-sm"
          style={{ marginBottom: 'var(--space-5)' }}
        >
          {t('Darslaringizga kirish uchun Telegram hisobingiz bilan kiring.')}
        </p>

        <div
          ref={widgetSlot}
          style={{ display: 'flex', justifyContent: 'center' }}
        />

        {error && (
          <div className="callout" style={{ marginTop: 'var(--space-4)' }}>
            <p className="text-sm">{error}</p>
          </div>
        )}

        {/*
          ZAXIRA YOʻL. Widget ishlamasa (domen bogʻlanmagan, freym
          bloklangan) foydalanuvchi qamalib qolmasligi kerak.
        */}
        <div
          style={{
            marginTop: 'var(--space-5)',
            paddingTop: 'var(--space-4)',
            borderTop: '1px solid var(--border)',
          }}
        >
          <p
            className="text-xs muted"
            style={{ marginBottom: 'var(--space-2)' }}
          >
            {t('Yuqoridagi tugma ishlamasa:')}
          </p>
          <a
            className="btn btn-secondary btn-block btn-sm"
            href={`https://t.me/${BOT_USERNAME}?start=sayt`}
            target="_blank"
            rel="noreferrer"
          >
            {t('Botdan kirish havolasini olish')}
          </a>
        </div>
      </div>
    </main>
  );
};
